import React from "react"
import {Row} from 'react-bootstrap'
// import VenueLocationOtp from "../../account-setup/venue-location/VenueLocationOtp";
import InputFieldSkeleton from "../../../../components/skeletons/InputFieldSkeleton";
import HeadingSkeleton from "../../../../components/skeletons/HeadingSkeleton";

export default function EditProfessionalSkeleton(options) {

    return(
        <div className={'signup'}>
            <div>
                <Row>
                    <InputFieldSkeleton/>
                    <InputFieldSkeleton/>
                    <InputFieldSkeleton/>
                    <InputFieldSkeleton/>
                </Row>
                <div className={'dfields'}>
                    <HeadingSkeleton height={50}/>
                </div>
            </div>
        </div>
    )
}